import Sbanner from '../images/smallbanner2.jpg';

export default function Smallbanner(){
    return(
        <div>
            <img src={Sbanner} alt="" width="100%" />   
        </div>
    );
}